export const getInitials = (first: string, last: string) =>
  `${first[0]}${last[0]}`.toUpperCase();

export const getInitialsFromFullName = (fullName: string) => {
  if (!fullName) return "";

  const parts = fullName.trim().split(/\s+/);

  const first = parts[0];
  const last = parts.length > 1 ? parts[parts.length - 1] : "";

  return `${first[0] ?? ""}${last[0] ?? ""}`.toUpperCase();
};

export const getTimeLabel = (date: string) => {
  const messageDate = new Date(date);
  const now = new Date();

  if (messageDate.toDateString() === now.toDateString()) {
    return messageDate.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
  }

  const yesterday = new Date();
  yesterday.setDate(now.getDate() - 1);

  if (messageDate.toDateString() === yesterday.toDateString()) {
    return "Yesterday";
  }

  return messageDate.toLocaleDateString();
};

export const getTimeLabelWithDay = (date: string): string => {
  const messageDate = new Date(date);
  const now = new Date();

  const timeFormatter: Intl.DateTimeFormatOptions = {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  };

  const isSameDay = (d1: Date, d2: Date) =>
    d1.toDateString() === d2.toDateString();

  if (isSameDay(messageDate, now)) {
    return `Today, ${messageDate.toLocaleTimeString([], timeFormatter)}`;
  }

  const yesterday = new Date(now);
  yesterday.setDate(now.getDate() - 1);

  if (isSameDay(messageDate, yesterday)) {
    return `Yesterday, ${messageDate.toLocaleTimeString([], timeFormatter)}`;
  }

  return messageDate.toLocaleString([], {
    year: "numeric",
    month: "short",
    day: "2-digit",
    ...timeFormatter,
  });
};

export const generateTempId = () =>
  `temp-${Date.now()}-${Math.random().toString(36).substring(2, 9)}`;
